import { toast } from 'sonner';

// Always the live domain: /api/share serves the per-property cover image to Facebook/Messenger/iMessage.
export const SHARE_ORIGIN = 'https://rcstudios.net';
export const shareLinkFor = (slug) => `${SHARE_ORIGIN}/api/share/${slug}`;

export const copyShareLink = async (slug) => {
  const url = shareLinkFor(slug);
  try {
    await navigator.clipboard.writeText(url);
    toast.success('Share link copied');
    return true;
  } catch {
    toast.message('Copy this link to share', { description: url });
    return false;
  }
};

// Native share sheet on phones; falls back to copying the link.
export const shareProperty = async (slug, title) => {
  const url = shareLinkFor(slug);
  if (navigator.share) {
    try {
      await navigator.share({ title: title || 'RC Studios property', text: title ? `${title} | RC Studios` : 'RC Studios', url });
      return 'shared';
    } catch (err) {
      if (err?.name === 'AbortError') return 'cancelled';
    }
  }
  return (await copyShareLink(slug)) ? 'copied' : 'failed';
};

const tag = (s) => (s || '').replace(/[^A-Za-z0-9]/g, '');

export const buildCaption = ({ address, city, state, photoCount, slug }) => {
  const place = [city, state || 'AZ'].filter(Boolean).join(', ');
  const cityTag = tag(city);
  const tags = [
    cityTag && `#${cityTag}RealEstate`, cityTag && `#${cityTag}AZ`, '#ArizonaRealEstate',
    '#JustListed', '#RealEstatePhotography', '#RCStudios',
  ].filter(Boolean).join(' ');
  return [
    `Just listed: ${address || place}`,
    '',
    `Take a look inside this ${city ? `${city} ` : ''}home${photoCount ? ` - ${photoCount} professional photos` : ''}, captured by RC Studios.`,
    '',
    `See the full gallery: ${shareLinkFor(slug)}`,
    '',
    `Real estate photography, drone and video for agents across ${place} and the Colorado River region. Book your next listing at rcstudios.net`,
    '',
    tags,
  ].join('\n');
};

export const copyCaption = async (details) => {
  const text = buildCaption(details);
  try {
    await navigator.clipboard.writeText(text);
    toast.success('Caption copied - paste it into your post');
    return true;
  } catch {
    toast.message('Copy this caption', { description: text });
    return false;
  }
};
